import { ReactNode, useEffect, useState } from "react";
import { AuthorizationContext } from "../AuthContext";
import { SingletonRefreshClient } from "../../Api/SingletonRefreshClient";
import { Authorized } from "../../Api/GetAuthedClientNonHook";
import { AuthRycApiClient, MeResponse } from "../../Api/ApiServer";

interface AuthorizationProviderProps {
    children: ReactNode;
}
const AuthProvider: React.FC<AuthorizationProviderProps> = ({ children }) => {
    const [token, setToken] = useState<string | null | undefined>(undefined);
    const [isInitialized, setIsInitialized] = useState<boolean>(false);
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [isSuperAdmin, setIsSuperAdmin] = useState<boolean>(false);
    const [userData, setUserData] = useState<MeResponse | null>(null);
    // SingletonRefreshClient.
    const isAuthenticated = !!token;

    useEffect(() => {

        const storedToken = localStorage.getItem('token');
        if (storedToken)
            Authorized<AuthRycApiClient>(storedToken).isLoggedIn().then(() => {
                if (storedToken) {
                    setToken(storedToken);

                }
                else setToken(null);
            }).catch(() => {
                setToken(null);
            });
        else setToken(null);
    }, []);
    useEffect(() => {
        if (token !== undefined) {
            setIsInitialized(true);
            if (token !== null)
                Authorized<AuthRycApiClient>(token).me().then((meData) => {
                    setIsAdmin(meData.isAdmin ?? false);
                    setIsSuperAdmin(meData.isSuperAdmin ?? false);
                    setUserData(meData);
                }).catch(() => {
                    setIsAdmin(false);
                });
        }
    }, [token]);

    const login = (newToken: string, refreshToken: string, isAdmin: boolean, isSuperAdmin: boolean) => {
        Authorized<AuthRycApiClient>(newToken).me().then((meData) => {
            setIsAdmin(meData.isAdmin ?? false);
            setIsSuperAdmin(meData.isSuperAdmin ?? false);
            setUserData(meData);
        }).catch(() => {
            setIsAdmin(false);
        });
        // setToken(newToken);
        // setIsAdmin(isAdmin);
        // setIsSuperAdmin(isSuperAdmin);
        localStorage.setItem('token', newToken);
        localStorage.setItem('refresh_token', refreshToken);
        // const storedToken = localStorage.getItem('token');
        // router.push('/dashboard');
    };

    const logout = () => {
        setToken(null);
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        // router.push('/login');
    };

    return (
        <AuthorizationContext.Provider value={{ userData, token, isAuthenticated, isInitialized, login, logout, isAdmin, isSuperAdmin }
        }>
            {children}
        </AuthorizationContext.Provider>
    );
};
export default AuthProvider;